<template>
  <div>
    <div style="padding: 20px; text-align: left;">
      <div style="text-align: left; margin-bottom: 10px;">
        <h3 style="margin-bottom: 10px; margin-top: -5px;">{{ $t('Login.birth') }}</h3>
        <mu-row gutter>
          <mu-col span="4">
            <mu-select label="year" v-model="birth.year" full-width>
              <mu-option v-for="(option, index) in 120" :key="index + 'y'" :label="(1900 + option).toString()" :value="(1900 + option).toString()"></mu-option>
            </mu-select>
          </mu-col>
          <mu-col span="4">
            <mu-select label="month" v-model="birth.month" full-width>
              <mu-option v-for="(option, index) in 12" :key="index + 'm'" :label="(option < 10) ? `0${option}` : option.toString()" :value="(option < 10) ? `0${option}` : option.toString()"></mu-option>
            </mu-select>
          </mu-col>
          <mu-col span="4">
            <mu-select label="date" v-model="birth.date" full-width>
              <mu-option v-for="(option, index) in 31" :key="index + 'd'" :label="(option < 10) ? `0${option}` : option.toString()" :value="(option < 10) ? `0${option}` : option.toString()"></mu-option>
            </mu-select>
          </mu-col>
        </mu-row>
      </div>
      <!-- Email -->
      <div style="text-align: left; margin-bottom: 10px;" v-if="isEmail">
        <h3 style="margin-bottom: 10px; margin-top: -5px;">{{ $t('Login.email') }}</h3>
        <mu-text-field v-model.trim="user.email" full-width :placeholder="$t('Login.email')"></mu-text-field>
      </div>
      <!-- Name -->
      <div style="text-align: left;">
        <h3 style="margin-bottom: 10px; margin-top: -5px;">{{ $t('Login.name') }}</h3>
        <mu-text-field v-model.trim="user.name" full-width :placeholder="$t('Login.name')"></mu-text-field>
      </div>
      <!-- Recommand -->
      <div style="text-align: left; margin-top: 15px;" v-if="isLoginRecom">
        <h3 style="margin-bottom: 10px; margin-top: -5px;">{{ $t('Login.input_recommend') }}
          <el-switch v-model="openRecom"
            style="margin-left: 5px; display: inline-block; transform: translateY(-2px) scale(0.9);"
            active-color="#13ce66"
            inactive-color="#999">
          </el-switch>
        </h3>
        <mu-text-field v-if="openRecom" v-model.trim="recomPhone" full-width :placeholder="$t('Login.please_input_recommend')"></mu-text-field>
      </div>
      <!-- 使用條款測試 -->
      <el-dialog fullscreen
        :visible.sync="privacyDia"
        :show-close="false">
        <el-button type="danger" size="small" @click="privacyDia = false">X 關閉</el-button>
        <iframe :src="privacyUrl" width="100%" style="height: calc(100vh - 250px); margin-top: 10px;"></iframe>
        <div style="font-size: 17px; text-align: center;" @click="privacyDia = false">
          <i class="el-icon-close"></i>關閉
        </div>
      </el-dialog>
      <div style="text-align: center;">
        <el-checkbox v-model="checked">
          我已閱讀並同意
        </el-checkbox>
        <span style="color: #f24; text-decoration: underline;" @click="privacyDia = true">會員使用條款</span>
      </div>
      <!-- 送出前檢查 -->
      <div v-if="showWarn" style="color: #f24; margin-top: 5px; margin-bottom: -10px;">{{ $t(warning) }}</div>
      <div style="margin-top: 20px; text-align: center;">
        <el-button type="primary" style="font-size: 20px; width: 100%; margin-right: 0;" @click="checkPush" :disabled="!checked">{{ $t('Store.send') }}</el-button>
      </div>
      <!-- loading -->
      <mu-dialog :open="pageLoading" width="70%">
        <div style="text-align: center;">
          <mu-circular-progress class="demo-circular-progress" :size="36"></mu-circular-progress>
          <div>{{ $t(loadingMsg) }}</div>
        </div>
      </mu-dialog>
      <!-- loading -->
      <mu-dialog :open.sync="warningDia" width="80%">
        <div style="height: 65vh; max-height: 430px; overflow-y: scroll; overflow-x: hidden;">
          <el-row style="margin-bottom: 15px;" :gutter="5">
            <el-col :span="9" style="text-align: right;">
              <img src="../warning.png" style="margin-right: 5px;"/>
            </el-col>
            <el-col :span="15" style="text-align: left;">
              <div style="font-size: 18px; font-weight: 600;">請留意</div>
            </el-col>
          </el-row>
          <div>您的電話號碼未經過簡訊驗證</div><br>
          <div>若您的註冊資料，並非您本人所屬，請勿註冊。</div><br>
          <div>冒用他人個資，可能涉及相關法律責任，如產生相關法律責任，須由您自行承擔相關損害賠償，或任何法律權益</div><br>
          <el-row :gutter="20">
            <el-col :span="3">
              <mu-checkbox v-model="allowNoVer"></mu-checkbox>
            </el-col>
            <el-col :span="20">
              <div style="font-size: 14px;">此註冊資料為我本人所有，且我同意上述注意事項。</div>
            </el-col>
          </el-row><br>
          <mu-button color="#982734" style="width: 100%;" :disabled="!allowNoVer" @click="sendMemberCheck">送出</mu-button>
        </div>
      </mu-dialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions, createNamespacedHelpers } from 'vuex';

const register = createNamespacedHelpers('register');

export default {
  data() {
    return {
      birth: {
        year: '1990',
        month: '01',
        date: '01'
      },
      user: {},
      recomPhone: '',
      checked: false,
      openRecom: true,
      basicHeight: 320,
      privacyDia: false,
      showWarn: false,
      pageLoading: false,
      warningDia: false,
      allowNoVer: false,
      loadingMsg: 'Login.loading',
      warning: ''
    };
  },
  props: ['birthData', 'userData', 'isEmail', 'isLoginRecom', 'privacyUrl', 'service', 'auth', 'autoRecom', 'requireEmail', 'noVer'],
  mounted() {
    this.birth.year  = this.birthData.year  ? this.birthData.year  : '1990';
    this.birth.month = this.birthData.month ? this.birthData.month : '01';
    this.birth.date  = this.birthData.date  ? this.birthData.date  : '01';
    this.user = this.userData;
  },
  methods: {
    ...register.mapActions({
      checkRecomPhone : 'checkRecomPhone',  // 檢查推薦電話
    }),
    checkRecom() {
      if (this.recomPhone === this.user.phone) {
        this.pageLoading = false;
        this.showWarn = true;
        this.warning = 'Login.used_Phone';
      }
      else {
        this.loadingMsg = 'Login.checking_recommend';
        const recom = this.recomPhone ? this.recomPhone : this.autoRecom;
        this.checkRecomPhone({ service: this.service, auth: this.auth, receivedPhone: this.user.phone, recomPhone: recom })
          .then((res) => {
            this.pageLoading = false;
            if (res.data.message.toLowerCase() === 'ok') {
              // 送推薦人
              this.$emit('sendMember', { user: this.user, recom });
            }
            else {
              if (!this.recomPhone) {
                this.$emit('sendMember', { user: this.user, recom: '' });
              }
              else {
                this.pageLoading = false;
                this.showWarn = true;
                this.warning = 'Login.used_Phone';
              }
            }
          })
      }
    },
    sendMemberCheck() {
      this.warningDia = false;
      if (this.recomPhone || this.autoRecom) {
        this.pageLoading = true;
        this.loadingMsg = 'Login.loading';
        this.checkRecom();
      }
      else {
        this.$emit('sendMember',  { user: this.user, recom: '' });
      }
    },
    checkPush() {
      this.user.birth = `${this.birth.year}${this.birth.month}${this.birth.date}`;
      // 檢查必要參數
      if (!this.user.name) {
        this.showWarn = true;
        this.warning = 'Login.no_name';
        return;
      }
      else if (this.requireEmail && !this.user.email) {
        this.showWarn = true;
        this.warning = 'Login.no_email';
        return;
      }
      else {
        this.showWarn = false;
        if (this.noVer) {
          this.warningDia = true;
        }
        else {
          this.sendMemberCheck();
        }
      }
    }
  }
}

</script>